export function canUser(user, module, action) {
  const role = String(user?.roleCode || '').toUpperCase();
  if (role === 'CENTERADMIN' || role === 'SUPERADMIN') return true;
  const permission = (user?.permissions || []).find(item =>
    String(item.module || '').toLowerCase() === String(module || '').toLowerCase());
  if (!permission) return false;
  const key = action === 'view' ? 'canView' : action === 'add' ? 'canAdd' : action === 'update' ? 'canUpdate' : 'canDelete';
  return permission[key] === true;
}

export function hasAnyModulePermission(user, module) {
  return canUser(user, module, 'view') || canUser(user, module, 'add') || canUser(user, module, 'update') || canUser(user, module, 'delete');
}
